"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupClient = void 0;
var models_1 = require("src/models");
var clients_1 = require("src/clients");
var classes_1 = require("src/classes");
var helpers_1 = require("src/helpers");
var errors_1 = require("src/errors");
/**
 * SDK for interacting with custom groups as defined in the code
 * https://git.empdev.domo.com/Development/domoapps/blob/29309abd2569d99d367a8f544dae9d4a7c1adc43/domoapps-server/src/main/scala/com/domo/domoapps/apps/users/resource/GroupResource.scala
 */
var GroupClient = /** @class */ (function () {
    function GroupClient() {
    }
    GroupClient.get = function (timeout) {
        if (timeout === void 0) { timeout = 0; }
        var url = models_1.EndpointsV1.group.toString();
        return clients_1.TransportClient.get(url, '', { accept: models_1.DataFormatTypes.json }, timeout);
    };
    GroupClient.getGroupByName = function (name, timeout) {
        if (timeout === void 0) { timeout = 0; }
        if (!(0, helpers_1.isString)(name))
            throw new errors_1.InvalidParamError();
        var params = new classes_1.URLSearchParams();
        params.set('groupName', name);
        var url = "".concat(models_1.EndpointsV1.group, "/name");
        return clients_1.TransportClient.get(url, params.toString(), { accept: models_1.DataFormatTypes.json }, timeout);
    };
    GroupClient.getGroupById = function (id, timeout) {
        if (timeout === void 0) { timeout = 0; }
        if (!(0, helpers_1.isNumber)(id))
            throw new errors_1.InvalidParamError();
        var url = "".concat(models_1.EndpointsV1.group, "/").concat(id);
        return clients_1.TransportClient.get(url, '', { accept: models_1.DataFormatTypes.json }, timeout);
    };
    GroupClient.getUserGroups = function (userId, timeout) {
        if (timeout === void 0) { timeout = 0; }
        var url = "".concat(models_1.EndpointsV1.group, "/user/").concat(userId);
        return clients_1.TransportClient.get(url, '', { accept: models_1.DataFormatTypes.json }, timeout);
    };
    return GroupClient;
}());
exports.GroupClient = GroupClient;
